import { useEffect, useState } from "react";

// Organisation logo/icon shown across the app. Fetched once from the public branding lookup (it is
// needed on the login and signing screens, before anyone is signed in) and shared by every
// <BrandLogo>. Call refreshBranding() after an admin uploads or removes an image.
const BASE = process.env.REACT_APP_BACKEND_URL || "";

let state = { loaded: false, logoUrl: null, iconUrl: null };
const listeners = new Set();
let inflight = null;

const publish = (next) => {
  state = next;
  listeners.forEach((fn) => fn(state));
};

export function refreshBranding() {
  if (!inflight) {
    inflight = fetch(`${BASE}/api/public/branding`, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then((d) =>
        publish({
          loaded: true,
          logoUrl: d.logo_url ? `${BASE}${d.logo_url}` : null,
          iconUrl: d.icon_url ? `${BASE}${d.icon_url}` : null,
        }))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useBranding() {
  const [s, setS] = useState(state);
  useEffect(() => {
    listeners.add(setS);
    if (!state.loaded) refreshBranding();
    else setS(state);
    return () => listeners.delete(setS);
  }, []);
  return s;
}

// Test hook: the state is module-level, so tests reset it between cases.
export function resetBrandingForTests() {
  state = { loaded: false, logoUrl: null, iconUrl: null };
  inflight = null;
  listeners.clear();
}
